import { LoadingState } from '../models';

export const initialLoadingState: LoadingState = {
  completed: false,
  failed: false,
  processing: false,
};
